import React from 'react';
import { buttonWithIconSidePadding, controlGraphicSize, controlIconSize, controlSizeFallback, cssControlSize, cssGraphicSize, getIconNumeric, slControlSize } from "../../styles/index.mjs";
import styled, { css } from "../../styled-components.mjs";
var Wrapper = styled.span.withConfig({
  displayName: "IconWrapper__Wrapper",
  componentId: "sc-1hf1hjl-0"
})(["", ""], function (_ref) {
  var $buttonSize = _ref.$buttonSize,
    $iconSize = _ref.$iconSize,
    $position = _ref.$position;
  var iconLeadingTrailingPosition = buttonWithIconSidePadding($buttonSize);
  var iconOnlyPosition = "calc((".concat(cssControlSize(slControlSize($buttonSize), controlSizeFallback[$buttonSize]), " - ").concat(cssGraphicSize(controlGraphicSize[$buttonSize], 'decorative', "".concat(getIconNumeric($iconSize), "px")), ") / 2)");
  return css(["display:flex;position:absolute;", " ", " ", ""], $position === 'only' && css(["inset-block-start:", ";inset-inline-start:", ";"], iconOnlyPosition, iconOnlyPosition), $position === 'leading' && css(["inset-inline-start:", ";"], iconLeadingTrailingPosition), $position === 'trailing' && css(["inset-inline-end:", ";"], iconLeadingTrailingPosition));
});
export var IconWrapper = function IconWrapper(_ref2) {
  var position = _ref2.position,
    buttonSize = _ref2.buttonSize,
    icon = _ref2.icon;
  var Icon = icon;
  var iconSize = controlIconSize[buttonSize];
  return /*#__PURE__*/React.createElement(Wrapper, {
    $position: position,
    $buttonSize: buttonSize,
    $iconSize: iconSize,
    "aria-hidden": "true"
  }, /*#__PURE__*/React.createElement(Icon, {
    size: iconSize
  }));
};